import { useEffect, useRef, useState } from 'react';

/**
 * Enable Recharts animation only when the underlying `data` reference changes.
 * Prevents sibling re-renders from looking like a full chart reload.
 */
export function useAnimateOnDataChange(data: unknown): boolean {
    const prevDataRef = useRef(data);
    const [animate, setAnimate] = useState(true);

    useEffect(() => {
        if (prevDataRef.current === data) {
            setAnimate(false);
            return undefined;
        }
        prevDataRef.current = data;
        setAnimate(true);
        const id = window.setTimeout(() => setAnimate(false), 800);
        return () => window.clearTimeout(id);
    }, [data]);

    return animate;
}
